import { useListMappingTransform, useTranslation } from 'src/hooks';
import { Preview } from '../types/Preview';
import { TableColumnKey, TableRow } from '../types/Table';

type Props = {
  previews: Preview[];
};

const useTableRows = ({ previews }: Props) => {
  const listMappingTransform = useListMappingTransform('table');
  const { t } = useTranslation('enumConstants');

  const mapJsonDataToTupleArray = (omitKeys: string[]) => {
    if (previews.length === 0) return [];
    return previews.map((item) => {
      const mappedResult = [
        [TableColumnKey.pfhNo, item.pfh_no],
        [TableColumnKey.CreditCurrency, item.credit_currency],
        [TableColumnKey.CreditAmount, item.credit_amount],
        [TableColumnKey.ValidationPass, item.validationPass ? t('yes') : t('no')],
        [TableColumnKey.ValidationError, item.validationError],
        ['rawData', item],
        ['paramData', item.paramData],
      ].filter(([key]) => !omitKeys.includes(key as string));

      return mappedResult;
    });
  };

  const res = mapJsonDataToTupleArray([]);
  const rows: TableRow[] = res.map(listMappingTransform);
  return { rows, mapJsonDataToTupleArray };
};

export default useTableRows;
